module.exports = __webpack_public_path__ + "files/0cb6a0ecf675d4cb456d26a7b9bf1b43.png";